import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, PageKeyAccessType, LocalService, Status, TriggeredEvent, Wrappers10, PageKey } from '../../../service/local.service';
import { MenuManagementService } from '../../../service/menu-management.service';
import { MenuConfigurationComponent } from '../../popups/menu-configuration/menu-configuration.component';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss']
})
export class MenusComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"];
  source: Wrappers10; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private menuManagementService: MenuManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Menus);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  openMenu(id: string) {
    const modalRef = this.modalService.open(MenuConfigurationComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.id = id;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
      }
    });
  }

  onLoad() {
    this.menuManagementService.getMenus(!this.source ? null : this.source.paging).subscribe(result => {
      this.source = result;
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.menuManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Menu).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.source.items.find(x => x.key == strId);
        updatedItem.v4 = updatedItem.v4 == "1" ? "0" : "1";
      }
    });
  }
}
